import Link from 'next/link'
import { List } from 'src/app-components/List'

import { ChevronRight } from '@fsg/icons'

type Props = {
  primary: React.ReactNode
  secondary: React.ReactNode
  tertiary: React.ReactNode
  href: string
  icon: React.ElementType
}

export function SalesListItem(props: Props) {
  const { primary, secondary, tertiary, href, icon: Icon } = props

  return (
    <List.ListItem className="border-b border-gray-400 text-sm last:border-b-0">
      <Link href={href} className="flex w-full flex-wrap items-center py-md gap-4xs hover:text-primary">
        <Icon className="mr-[3px] inline" />
        <span className="font-bold">{primary}</span>
        {secondary ? (
          <>
            {primary ? <span className="mx-1">{'·'}</span> : null}
            <span className="text-ellipsis">{secondary}</span>
          </>
        ) : null}
        <div className="ml-auto flex items-center">
          <span>{tertiary}</span>
          <ChevronRight />
        </div>
      </Link>
    </List.ListItem>
  )
}
